
<template>
<div  class="container-fluid">
  <b-card>
    <div v-for="n in numberOfCriteria" :key="n">
      <b-card-text>
        <div id="selectOperator" class="row" v-if="numberOfCriteria > 1 && n != 1">
          <div class="col-2">
            <h5> Opérateur: </h5>
          </div>
          <div class="col-2">
            <b-form-select v-model="selectedOperator">
              <option>ET</option>
              <option>OU</option>
            </b-form-select>
          </div>
        </div>
        <div class="row">
          <div class="col-6">
            <h5> Critère {{n}} </h5>
            <treeselect :options="conceptTree" placeholder="Selection de catégories grammaticales..." v-model="conceptsValue[n-1]" @input="findProps(n-1)" />
          </div>
          <div class="col-4">
            <h5> Propriété </h5>
            <treeselect :multiple="true" :options="props[n-1]" :default-expand-level="1" :disable-branch-nodes="true" value="ORDER_SELECTED" placeholder="Choix d'une ou plusieurs propriété..." v-model="propsValue[n-1]" />
          </div>
        </div>
      </b-card-text>  
    </div>
      <b-button id="criteriaButtons" variant="outline-success" @click="find()">Rechercher</b-button>
      <b-button id="criteriaButtons" v-if="mapListForTable.length > 0" variant="outline-secondary" @click="reset()">Réinitialiser</b-button>
      <b-button id="criteriaButtons" v-if="numberOfCriteria < 2" variant="outline-primary" @click="addCriteria()">Ajouter un critère</b-button>
      <b-button id="criteriaButtons" v-if="numberOfCriteria > 1" variant="outline-danger" @click="removeCriteria()">Supprimer un critère</b-button>
  </b-card>
  <br>
  <b-card :title="`Résultat de la requête (` + mapListForTable.length + ` cartes)`" class="overflow-auto" v-if="mapListForTable.length != 0">
      <b-card-text>
       <map-table-result v-bind:mapListForTable="mapListForTable"></map-table-result>
      </b-card-text>
  </b-card>
</div>
</template>

<script>
import { mapGetters } from 'vuex'
import Treeselect from '@riophae/vue-treeselect'
import MapTableResult from './MapTableResult'

export default {
  name: 'grammatical-search',
  components: { Treeselect, MapTableResult },
  computed: {
    ...mapGetters({
      mapListForTable: 'getMapsWithGramCatList',
      props: 'getProps'
    })
  },
  watch: {
    props() {
      this.props
    }
  },
  methods: {
    // Recherche des propriétés associées à la catégorie grammaticale d'index "index"
    findProps: function(index) {
      if (this.propsValue[index]) {
        this.propsValue.splice(index, 1)
      }
      this.$store.dispatch('findProps', { concept: this.conceptsValue[index], index: index })
    },
    // Envoie de la recherche de carte
    find: function () {
      let selectedProperties = []
      for (let i = 0; i < this.conceptsValue.length; i++) {
        selectedProperties.push({
          "concept": this.conceptsValue[i],
          "properties": this.propsValue[i],
          "operator": this.selectedOperator
        })
      }
      if (this.numberOfCriteria === 1) {
        this.$store.dispatch('findMapsWithGramCat', { selectedProperties: selectedProperties })
      } else {
        this.$store.dispatch('findMapsWithGramCatWithOperator', { selectedProperties: selectedProperties })
      }
    },
    // Ajoute un nouveau critère de recherche
    addCriteria: function() {
      return this.numberOfCriteria += 1
    },
    // Supprime le deuxième critère de recherche et les derniers éléments des tableaux concepts et propsValue
    removeCriteria: function() {
      this.conceptsValue.pop()
      this.propsValue.pop()
      return this.numberOfCriteria -= 1
    },
    reset: function() {
      this.conceptsValue.length = 0
      this.propsValue.length = 0
      this.numberOfCriteria = 1
      this.$store.dispatch('resetMapsWithGramCatList')
    }
  },
  data() {
    return {
      numberOfCriteria: 1,
      conceptsValue: [],
      selectedOperator: "ET",
      propsValue: [],
      conceptTree: [{
          id: 'adjectif',
          label: 'Adjectif',
          children: [
            { id: 'adjNumeral', label: 'Numéral' },
            { id: 'adjParticipe', label: 'Participe' },
            { id: 'adjPersonnel', label: 'Personnel' },
            { id: 'adjQualificatif', label: 'Qualificatif' },
          ]
        },
        {
          id: 'adverbe',
          label: 'Adverbe',
          children: [
            { id: 'advDivers', label: 'Divers' },
            { id: 'advInterrogatif', label: 'Interrogatif' }
          ]
        },
        {
          id: 'conjonction',
          label: 'Conjonction',
          children: [
            { id: 'conjCoordination', label: 'Coordination' },
            { id: 'conjSubordination', label: 'Subordination' },
            { id: 'conjAutres', label: 'Autres' }
          ]
        },
        {
          id: 'determinant',
          label: 'Déterminant',
          children: [{
              id: 'article',
              label: 'Article',
              children: [
                { id: 'articleDefini', label: 'Défini' },
                { id: 'articleIndefini', label: 'Indéfini' },
                { id: 'articlePartitif', label: 'Partitif' }
              ]
            },
            { id: 'determinantDemonstratif', label: 'Démonstratif' },
            { id: 'determinantExclamatif', label: 'Exclamatif' },
            { id: 'determinantIndefini', label: 'Indéfini' },
            { id: 'determinantInterrogatif', label: 'Interrogatif' },
            { id: 'determinantPossessif', label: 'Possessif' },
          ]
        },
        {
          id: 'nom',
          label: 'Nom',
          children: [
            { id: 'nomCommum', label: 'Nom Commun' },
            { id: 'nomPropre', label: 'Nom Propre' }
          ]
        },
        {
          id: 'preposition',
          label: 'Préposition'
        },
        {
          id: 'pronom',
          label: 'Pronom',
          children: [
            { id: 'pronomDemonstratif', label: 'Démonstratif' },
            { id: 'pronomImpersonnel', label: 'Impersonnel' },
            { id: 'pronomIndefini', label: 'Indéfini' },
            { id: 'pronomInterrogatif', label: 'Interrogatif' },
            { id: 'pronomPersonnel', label: 'Personnel' },
            { id: 'pronomRelatif', label: 'Relatif' }
          ]
        },
        {
          id: 'verbe',
          label: 'Verbe',
          children: [
            { id: 'verbeConjugue', label: 'Conjugué' },
            { id: 'verbeInfinitif', label: 'Infinitif' },
            { id: 'verbeParticipe', label: 'Participe' }
          ]
        },
      ]
    }
  }
}
</script>
<style>
#criteriaButtons {
  margin: 10px;
}

#selectOperator {
  margin: 20px;
}
.card-title {
    margin-bottom: 40px;
    text-align: left;
    margin-top: 25px;
}
</style>



// WEBPACK FOOTER //
// src/components/search/GrammaticalSearch.vue